export enum UserRole {
  Customer = "Customer",
  User = "User",
  View = "View"
}

export enum RoleJoinMeeting {
  OPERATOR = "OPERATOR",
  PARTICIPANT = "PARTICIPANT"
}